import styled from "styled-components";

export const TitleBB = styled.div`
  font-size: 1rem;
  margin-bottom: 5px;
  color: #f9ae17;
  font-weight: 600;
`;

export const ButtonRemove = styled.button`
  font-size: 1rem;
  color: #ff0000;
  font-weight: 600;
  background: transparent;
  border: 1px solid #ff0000;
  margin-bottom: 10px;
`;

export const ButtonCheck = styled.button`
  font-size: 1rem;
  color: #207838;
  font-weight: 600;
  background: transparent;
  border: 1px solid #207838;
  margin-bottom: 10px;
  cursor: default;
`;

export const TitleJunction = styled.div`
  font-size: 1.2rem;
  margin-bottom: 5px;
  color: #203b34;
  font-weight: 600;
  text-decoration: underline;
`;
export const ButtonClose = styled.button`
  font-size: 1rem;
  border: 0px;
  background: transparent;
`;

export const IconButton = styled.i`
  font-size: 1rem;
  margin-right: 10px;
`;

export const Title = styled.h3`
  /* font-size: 1rem; */
  margin-right: 10px;
`;

export const ContainerData = styled.div`
  border: 1px solid #f9ae17;
  padding: 10px 15px;
  border-radius: 10px;
`;

export const LabelData = styled.span`
  font-weight: bold;
  color: #203b34;
  margin-right: 10px;
`;

export const ContainerBB = styled.div`
  border: 1px solid #203b34;
  padding: 10px 15px;
  min-height: 250px;
`;

export const FormSection = styled.div`
  margin-bottom: 2rem;

  .form-control,
  .input-wrapper {
    width: 100%;
  }
`;

export const SectionLabel = styled.label`
  display: block;
  font-size: 0.95rem;
  font-weight: 600;
  color: #2c3e35;
  margin-bottom: 0.5rem;

  ${(props) =>
    props.mandatory &&
    `
    &::after {
      content: " *";
      color: #dc3545;
    }
  `}
`;

export const HelpText = styled.p`
  font-size: 0.85rem;
  color: #6c757d;
  margin: 0.5rem 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;

  i {
    color: #f9ae17;
  }
`;

export const LocationsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  gap: 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
`;

export const LocationPanel = styled.div`
  border: 1px solid #dee2e6;
  border-radius: 6px;
  /* overflow: hidden; */
  background: #fff;
`;

export const PanelHeader = styled.div`
  background: #f8f9fa;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #dee2e6;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 500;
  color: #495057;
  font-size: 0.9rem;
`;

export const ItemCount = styled.span`
  background: ${(props) => (props.selected ? "#f9ae17" : "#6c757d")};
  color: #fff;
  padding: 0.2rem 0.6rem;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
`;

export const SearchBox = styled.div`
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #dee2e6;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: #fff;

  i {
    color: #6c757d;
    font-size: 0.9rem;
  }

  .search-input {
    border: none;
    outline: none;
    flex: 1;
    font-size: 0.9rem;
    color: #495057;
    background: transparent;

    &::placeholder {
      color: #adb5bd;
    }
  }
`;

export const LocationList = styled.div`
  height: 300px;
  overflow-y: auto;
  overflow-x: hidden;

  .no-items,
  .no-items-selected {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: #adb5bd;
    font-size: 0.9rem;
    text-align: center;
    padding: 2rem;
  }

  /* Scrollbar styling */
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f8f9fa;
  }

  &::-webkit-scrollbar-thumb {
    background: #cbd5e0;
    border-radius: 4px;

    &:hover {
      background: #a0aec0;
    }
  }
`;

export const LocationItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #f1f3f5;
  font-size: 0.9rem;
  color: #495057;
  transition: all 0.15s ease;
  cursor: pointer;
  user-select: none;
  background-color: ${(props) => (props.$selected ? "#e7f3ff" : "transparent")};
  border-left: ${(props) =>
    props.$selected ? "3px solid #f9ae17" : "3px solid transparent"};

  &:hover {
    background-color: ${(props) => (props.$selected ? "#d6ecff" : "#f8f9fa")};
  }

  &:active {
    background-color: #e9ecef;
  }

  &:last-child {
    border-bottom: none;
  }

  span {
    flex: 1;
    font-weight: ${(props) => (props.$selected ? "600" : "normal")};
  }

  .action-btn {
    background: transparent;
    border: none;
    color: #6c757d;
    cursor: pointer;
    padding: 0.25rem 0.5rem;
    font-size: 0.85rem;
    transition: color 0.15s ease;

    &:hover {
      color: #f9ae17;
    }
  }
`;

export const TransferButtons = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.5rem;
  padding: 1rem 0;
`;

export const TransferButton = styled.button`
  background: #fff;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  padding: 0.5rem 0.75rem;
  cursor: pointer;
  color: #495057;
  transition: all 0.15s ease;
  font-size: 1rem;

  &:hover:not(:disabled) {
    background: #f9ae17;
    border-color: #f9ae17;
    color: #fff;
    transform: scale(1.05);
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  i {
    display: block;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  margin-top: 2rem;
  padding-top: 1rem;
`;

export const CancelButton = styled.button`
  background: #6c757d;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 1rem 2rem;
  font-size: 1.05rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 150px;

  &:hover {
    background: #5a6268;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(108, 117, 125, 0.3);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const ActionButton = styled.button`
  background: #f9ae17;
  color: #2c3e35;
  border: none;
  border-radius: 6px;
  padding: 1rem 2rem;
  font-size: 1.05rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 200px;

  &:hover {
    background: #e89d0f;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(249, 174, 23, 0.3);
  }

  &:active {
    transform: translateY(0);
  }
`;
